import React, { SVGProps } from "react";

export default function SupTrash(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7.64704 14.2353V8.58824H8.58822V14.2353H7.64704Z" fill="currentColor" />
      <path d="M11.4118 8.58824V14.2353H12.3529V8.58824H11.4118Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1765 4.82353V3.88235C15.1765 2.84276 14.3337 2 13.2941 2H6.70587C5.66627 2 4.82352 2.84276 4.82352 3.88235V4.82353H2.94116V5.76471H3.88234V14.2353C3.88234 16.3145 5.56785 18 7.64704 18H12.3529C14.4321 18 16.1176 16.3145 16.1176 14.2353V5.76471H17.0588V4.82353H15.1765ZM5.76469 3.88235V4.82353H14.2353V3.88235C14.2353 3.36256 13.8139 2.94118 13.2941 2.94118H6.70587C6.18607 2.94118 5.76469 3.36256 5.76469 3.88235ZM4.82352 5.76471V14.2353C4.82352 15.7947 6.08765 17.0588 7.64704 17.0588H12.3529C13.9123 17.0588 15.1765 15.7947 15.1765 14.2353V5.76471H4.82352Z"
        fill="currentColor"
      />
    </svg>
  );
}
